import React from 'react';

import analytics from '@repo/analytics';
import { withEventScope } from '@repo/event-processor';
import { Spacer } from '@repo/ui/components/Spacer';
import { H5 } from '@repo/ui/components/Typography';
import { themeStyle } from '@repo/ui/theming';

import { FILTERS_PREFIX } from 'global/analyticsEvents';
import { useTemplatesCategory } from 'global/utils/useTemplatesParams';
import { FlexColumn } from 'styles/layouts';

import { getRefineTagsByCategory } from './config';
import { RefineContainer, RefineImageContainer, RefineOverlay } from './styles';
import { SubUseCaseSectionProps } from './type';

const RefineByStyles: React.FC<SubUseCaseSectionProps> = ({
  tagGroups,
  filters,
  setFilters,
}) => {
  const currentCategorySlug = useTemplatesCategory();

  const tagsByCategory = currentCategorySlug
    ? getRefineTagsByCategory(currentCategorySlug)
    : [];

  const onRefineClick = ({ slug, label }: { slug: string; label: string }) => {
    void analytics.track(`${FILTERS_PREFIX}:refineByStyle`, {
      option: { slug, label },
    });

    // Find the tag group name to set the filter key
    const tagGroupName =
      tagGroups
        .find((tagGroup) =>
          tagGroup.tags.some((groupedTag) => groupedTag.name === slug)
        )
        ?.name?.toLocaleLowerCase() || 'styles';

    setFilters({
      ...filters,
      [tagGroupName]: { id: slug, label: slug },
    });
  };

  return (
    <RefineContainer>
      <H5>Refine by style</H5>
      <Spacer height="8px" />
      <FlexColumn gap="8px">
        {tagsByCategory?.map((tag) => (
          <RefineImageContainer
            key={tag.slug}
            backgroundImage={tag.image}
            onClick={() => onRefineClick(tag)}
          >
            <RefineOverlay>
              <H5 color={themeStyle.inkBase}>{tag.label}</H5>
            </RefineOverlay>
          </RefineImageContainer>
        ))}
      </FlexColumn>
    </RefineContainer>
  );
};

export default withEventScope(RefineByStyles, { module: 'refineByStyles' });
